import React from "react";
import { Column } from '@ant-design/plots';
import { Skeleton } from "antd";


export const ColumnChart = (props) => {
  const { channelVsProfit, isLoading } = props;

  if (isLoading || !channelVsProfit) {
    return <Skeleton />;
  }
  const chartContainerStyle = {
    height: '200px', 
  };
  const config = {
    data: channelVsProfit,
    xField: 'type',
    yField: 'sales',
    label: {
      position: 'middle',
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: {
        alias: 'Channel',
      },
      sales: {
        alias: 'Profit',
      },
    }
  };
  return (
    <div style={chartContainerStyle}>
      <Column {...config} />
    </div>
  );
};

